import React, { useEffect } from 'react';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

export interface LCAlertProps {
    onRef: any;
    details: string;
    type: 'success' | 'info' | 'warning' | 'error';
    title?: string;
    open?: boolean;
}

const LCAlert = (props: LCAlertProps): JSX.Element => {
    const { title, open, details, type, onRef } = props;

    const [isOpen, setIsOpen] = React.useState<boolean>(open ?? false);

    useEffect(() => {
        if (onRef) {
            onRef({ showAlert: showAlert, closeAlert: closeAlert });
        }
        return () => {
            if (onRef) {
                onRef(undefined);
            }
        };
    }, [onRef]);

    const showAlert = (): void => setIsOpen(true);

    const closeAlert = (): void => setIsOpen(false);

    const handleOnClick = (): void => setIsOpen(false);

    return (
        <Collapse in={isOpen}>
            <Alert
                severity={type}
                action={
                    <IconButton aria-label="close" color={'inherit'} size="small" onClick={handleOnClick}>
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                {title && <AlertTitle>{title}</AlertTitle>}
                {details}
            </Alert>
        </Collapse>
    );
};

export default LCAlert;
